import Spinner from 'components/icons/Spinner';

const Loading = () => (
  <div className="h-2/3 flex flex-col">
    <Spinner width="40" className="flex-1 m-auto mt-6 animate-spin" />
  </div>
);

export default Loading;
